<template>
  <div vocab="https://schema.org/" typeof="BreadcrumbList" class="e-breadcrumbs mb-4">
      <span :key="`item-${index}`" v-for="(step, index) in breadcrumbs">
        <template v-if="step.id || step.href">
          <a @click.prevent="clickBreadcrumb(step)">{{ step.name }}</a><span class="e-breadcrumbs__sep">&gt;</span>
        </template>
        <span v-else>{{ step.name }} </span>
      </span>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  components: {},
  name: 'Breadcrumbs',
  data() {
    return {};
  },
  computed: {
    ...mapState(['initBreadcrumbs']),
    ...mapGetters(['breadcrumbs']),
  },
  methods: {
    ...mapActions(['goToStep', 'setBreadcrumbs']),
    clickBreadcrumb(item) {
      if (item.href) {
        this.goToStep(null);
        if (this.$route.path !== item.href) {
          this.$router.push(item.href);
          const index = this.initBreadcrumbs.findIndex((step) => step.name === item.name);
          const steps = this.initBreadcrumbs.slice(0, index + 1);
          this.setBreadcrumbs(steps);
        }
      } else if (item.id) {
        this.goToStep(item.id);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
